import { toast } from 'react-toastify';

export const validateFormStrength = (
    title: string,
    coreValue: number,
    description: string
    // skill: number,
    // behavior: number,
    // isUseCoachingSkills: any
) => {
    const errors: string[] = [];
    if (title.trim().length === 0) {
        errors.push('Title is required \n');
    }
    if (!coreValue || coreValue === 0) {
        errors.push('Core value is required \n');
    }
    if (description.trim().length < 10) {
        errors.push('Description is required and must be at least 10 characters \n');
    }

    // if (isUseCoachingSkills === false && (!coreValue || coreValue === 0)) {
    //     errors.push('TTEC value is required \n');
    // }

    // if (isUseCoachingSkills === true) {
    //     if (!skill || skill === 0) {
    //         errors.push('Skill is required \n');
    //     }

    //     if (!behavior || behavior === 0) {
    //         errors.push('Behavior is required \n');
    //     }
    // }

    if (errors.length > 0) {
        errors.forEach((error) => toast.error(error));
        return false;
    }
    return true;
};
